import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ViewCaterer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const viewData = location.state?.mobileBarData || [];

    const [viewCaterer] = useState(viewData);

    // * data showing in card details
    const data = {
        fullName: viewCaterer.full_name,
        email: viewCaterer.email,
        phone: viewCaterer.phone,
        eventDate: viewCaterer.event_date,
        startTime: viewCaterer.start_time,
        endTime: viewCaterer.end_time,
        eventType: viewCaterer.event_type,
        otherEventType: viewCaterer.event_type_other,
        guests: viewCaterer.no_of_guest,
        venueName: viewCaterer.venue_name,
        venueAddress: viewCaterer.venue_address,
        vendorAccess: viewCaterer.loading_access,
        catering_style: viewCaterer.catering_style,
        catering_style_other: viewCaterer.catering_style_other,
        menu_type: viewCaterer?.menu_type?.map((pre) => pre),
        serving_staff: viewCaterer.serving_staff,
        req_tableware: viewCaterer.req_tableware, 
        catering_setup: viewCaterer.catering_setup,
        beverages: viewCaterer.beverages,
        budget: viewCaterer.budget_range,
        notes: viewCaterer.note,
        status: viewCaterer.status
    };

    return (
        <>
            <div className='page-content px-4' style={{ zIndex: '1' }}>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12 px-0'>
                            <div className='page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>View Caterer</h4>

                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0 d-flex flex-wrap gap-1'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active pointer' onClick={() => navigate(-1)}>Quotations</li>
                                        <li className='breadcrumb-item active'>View Caterer</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='p-6 rounded row'>

                                    {/* //* Contact Information */}
                                    <div className='mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4'>
                                        <div className=' rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4 className='text-xl fw-bold  mb-0 quotation-title py-2 px-3' style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Contact Information</h4>

                                            <div className='p-3'>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <strong>Full Name:</strong>
                                                    <span>{data.fullName}</span>
                                                </div>

                                                <div className='d-flex justify-content-between mb-2'>
                                                    <strong>Email:</strong>
                                                    <span>{data.email}</span>
                                                </div>

                                                <div className='d-flex justify-content-between mb-0'>
                                                    <strong>Phone:</strong>
                                                    <span>{data.phone}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Event Details */}
                                    <div className='mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4'>
                                        <div className='rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4
                                                className='text-xl fw-bold mb-0 quotation-title py-2 px-3'
                                                style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}
                                            >
                                                Event Details
                                            </h4>

                                            <div className='p-3'>
                                                <div className='row'>
                                                    {/* Column 1 */}
                                                    <div className='col-12 col-sm-6'>
                                                        <div className='d-flex justify-content-between mb-2'>
                                                            <strong>Date:</strong>
                                                            <span>{data.eventDate}</span>
                                                        </div>

                                                        <div className='d-flex justify-content-between mb-2'>
                                                            <strong>Catering Start Time:</strong>
                                                            <span>{data.startTime}</span>
                                                        </div>

                                                        <div className='d-flex justify-content-between'>
                                                            <strong>Catering End Time:</strong>
                                                            <span>{data.endTime}</span>
                                                        </div>
                                                    </div>

                                                    {/* Column 2 */}
                                                    <div className='col-12 col-sm-6'>
                                                        <div className='d-flex justify-content-between mb-2'>
                                                            <strong>Event Type:</strong>
                                                            <span>{data.eventType === 'Other' ? data.otherEventType : data.eventType}</span>
                                                        </div>

                                                        <div className='d-flex justify-content-between mb-0'>
                                                            <strong>Guests:</strong>
                                                            <span>{data.guests}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Location Details */}
                                    <div className='mb-4 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 '>
                                        <div className=' rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4 className='text-xl fw-bold  mb-0 quotation-title py-2 px-3' style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Location Details</h4>

                                            <div className='p-3'>
                                                <div className='d-flex justify-content-between mb-2'>
                                                    <strong>Venue Name:</strong>
                                                    <span>{data.venueName || 'N/A'}</span>
                                                </div>

                                                <div className='d-flex justify-content-between mb-2'>
                                                    <strong>Address:</strong>
                                                    <span>{data.venueAddress}</span>
                                                </div>

                                                <div className='d-flex justify-content-between mb-0'>
                                                    <strong>Loading Access:</strong>
                                                    <span>{data.vendorAccess}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* caterer Requirements */}
                                    <div className='mb-4 mb-xxl-0 col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4'>
                                        <div className='rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4
                                                className='text-xl fw-bold mb-0 quotation-title py-2 px-3'
                                                style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}
                                            >
                                                Catering Requirements
                                            </h4>

                                            <div className='p-3'>
                                                {/* <div className='row mb-2'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Catering Style:</div>
                                                    <div className='col-6 col-md-8 text-start'>{data.eventType === 'Other' ? data.catering_style_other : data.catering_style}</div>
                                                </div> */}

                                                <div className='row mb-2'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Menu Type:</div>
                                                    <div className='col-6 col-md-8 text-start'>{data.menu_type?.join(', ')}</div>
                                                </div>

                                                {data.specificBartenders && (
                                                    <div className='row mb-2'>
                                                        <div className='col-6 col-md-4 fw-bold text-nowrap'>Specific Number:</div>
                                                        <div className='col-6 col-md-8 text-start'>{data.specificBartenders}</div>
                                                    </div>
                                                )}

                                                <div className='row mb-2'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Serving Staff:</div>
                                                    <div className='col-6 col-md-8 text-start'>{data.serving_staff}</div>
                                                </div>

                                                <div className='row mb-2'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Tableware:</div>
                                                    <div className='col-6 col-md-8 text-start' style={{ textAlign: 'justify' }}>
                                                        {data.req_tableware}
                                                    </div>
                                                </div>

                                                <div className='row mb-2'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Catering Setup:</div>
                                                    <div className='col-6 col-md-8 text-start'>{data.catering_setup}</div>
                                                </div>

                                                {/* <div className='row'>
                                                    <div className='col-6 col-md-4 fw-bold text-nowrap'>Beverages:</div>
                                                    <div className='col-6 col-md-8 text-start'>{data.beverages}</div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Budget Range */}
                                    <div className=' mb-4 mb-md-0  col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4'>
                                        <div className=' rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4 className='text-xl fw-bold  mb-0 quotation-title py-2 px-3' style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Budget Range</h4>
                                            <div className='p-3'>
                                                <div className='d-flex justify-content-between'>
                                                    <strong>Budget Range:</strong>
                                                    <span>{data.budget}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* Additional Notes */}
                                    <div className='col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 '>
                                        <div className=' rounded shadow-sm' style={{ background: '#e8fff4' }}>
                                            <h4 className='text-xl fw-bold  mb-0 quotation-title py-2 px-3' style={{ background: '#6BCF9E', borderTopRightRadius: '0.375rem', borderTopLeftRadius: '0.375rem' }}>Additional Notes</h4>

                                            <div className='p-3'>
                                                <div className='d-flex justify-content-between'>
                                                    <span >{data.notes || 'None'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ViewCaterer;